import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36e30d03&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=36e30d03&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=36e30d03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e30d03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e30d03')) {
      api.createRecord('36e30d03', component.options)
    } else {
      api.reload('36e30d03', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36e30d03&scoped=true&", function () {
      api.rerender('36e30d03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Items/TimeCounter/index.vue"
export default component.exports